import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

import AccommodationPackageTile from 'components/AccommodationKit/AccommodationPackageTile'
import AccommodationPackageTileContentArea from 'components/AccommodationKit/AccommodationPackageTileContentArea'
import AccommodationPackageTileDetails from 'components/AccommodationKit/AccommodationPackageTileDetails'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OfferPagePackageInclusionsList from 'components/OfferPage/OfferPagePackageInclusionsList'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { preventRenderWithOpenFilter } from 'lib/offer/offerPageUtil'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'

function isValidInclusion({ minDuration, maxDuration }: App.OfferInclusion, duration: number): boolean {
  return (
    (minDuration == null || duration >= minDuration) &&
    (maxDuration == null || duration <= maxDuration)
  )
}

interface Props {
  propertyRoom: App.Property.Room
  duration: number
}

function PropertyAnytimeRateOption(props: Props) {
  const { propertyRoom, duration } = props

  const intl = useIntl()
  const [inclusions, bonusInclusions, luxPlusInclusions] = useMemo(() => [
    propertyRoom.inclusions.filter(inclusion => isValidInclusion(inclusion, duration)),
    propertyRoom.bonusInclusions.filter(inclusion => isValidInclusion(inclusion, duration)),
    propertyRoom.luxPlusInclusions.filter(inclusion => isValidInclusion(inclusion, duration)),
  ], [propertyRoom, duration])

  if (inclusions.length === 0 && bonusInclusions.length === 0 && luxPlusInclusions.length === 0) return null

  return <AccommodationPackageTile>
    <AccommodationPackageTileContentArea>
      <AccommodationPackageTileDetails rateName={intl.formatMessage({
        id: 'trqQDGWAZB',
        defaultMessage: 'Select dates to unlock package options',
        description: 'Placeholder text when dates aren\'t selected for property anytime rate option',
      })}
      />
      <div>
        <LargeContentToggle
          maxHeight={208}
          showMoreText={intl.formatMessage({
            id: 'HYsmEAZvwG',
            defaultMessage: 'View more inclusions',
            description: 'Toggle text to expand inclusions list for property anytime rate option',
          })}
          showLessText={intl.formatMessage({
            id: '3nlGejct7M',
            defaultMessage: 'View less inclusions',
            description: 'Toggle text to collapse inclusions list for property anytime rate option',
          })}
        >
          <VerticalSpacer gap={12}>
            {luxPlusInclusions.length > 0 && <LuxPlusInclusions
              luxPlusInclusions={luxPlusInclusions}
            />}
            {bonusInclusions.length > 0 && <OfferPagePackageInclusionsList title="bonus">
              {bonusInclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
            </OfferPagePackageInclusionsList>}
            {inclusions.length > 0 && <VerticalSpacer gap={4}>
              {inclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
            </VerticalSpacer>}
          </VerticalSpacer>
        </LargeContentToggle>
      </div>
    </AccommodationPackageTileContentArea>
  </AccommodationPackageTile>
}

export default withOfferPageState((state) => ({
  duration: state.duration,
  open: !!state.activeFilter,
}), PropertyAnytimeRateOption, preventRenderWithOpenFilter)
